import React from "react";
import {
  FaLightbulb,
  FaRegClock,
  FaPlaneDeparture,
  FaUmbrellaBeach,
  FaGift,
  FaMoneyBillWave,
} from "react-icons/fa";

const benefits = [
  {
    id: 1,
    title: "Creativity",
    desc: "Fosters innovation, encourages fresh ideas, and allows unique problem-solving approaches.",
    icon: <FaLightbulb size={26} />,
  },
  {
    id: 2,
    title: "Flexible Hours",
    desc: "Work at your own pace, ensuring a balanced work-life harmony.",
    icon: <FaRegClock size={26} />,
  },
  {
    id: 3,
    title: "Work & Travel",
    desc: "Explore new places while working, blending productivity with cultural experiences.",
    icon: <FaPlaneDeparture size={26} />,
  },
  {
    id: 4,
    title: "Paid Leave",
    desc: "Time off with pay to recharge and maintain mental well-being.",
    icon: <FaUmbrellaBeach size={26} />,
  },
  {
    id: 5,
    title: "Yearly Bonuses",
    desc: "Annual rewards for exceptional performance, recognizing hard work and dedication.",
    icon: <FaGift size={26} />,
  },
  {
    id: 6,
    title: "Smart Salary",
    desc: "Competitive pay aligned with skills, experience, and market standards.",
    icon: <FaMoneyBillWave size={26} />,
  },
];

const Benifits = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white py-12 ">
      <div className="pointer-events-none absolute -top-36 -left-32 h-80 w-80 rounded-full bg-[#064585]/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -right-28 h-96 w-96 rounded-full bg-[#5989C8]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 ">
        {/* Header */}
        <div className="text-center mb-10" data-aos="fade-up">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900">
            Benefits that You{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
              Get From Us
            </span>
            !
          </h1>
          <p className="mt-4 text-slate-600 text-sm md:text-base max-w-2xl mx-auto">
            Enjoy flexibility, creative freedom, paid leave, work-travel
            opportunities, yearly bonuses, and a smart salary — all designed to
            support your success.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((b, idx) => (
            <article
              key={b.id}
              className="group bg-white/80 backdrop-blur-lg border border-[#5989C8]/15 rounded-2xl p-6 md:p-7 shadow-sm hover:shadow-lg transform transition-all duration-300 hover:-translate-y-1"
              data-aos="fade-up"
              data-aos-delay={idx * 60}
            >
              <div className="flex items-center justify-between">
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585] text-white shadow-md"
                  aria-hidden="true"
                >
                  {b.icon}
                </div>
                <div className="text-4xl font-extrabold text-right text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] to-[#064585] opacity-90">
                  {String(idx + 1).padStart(2, "0")}
                </div>
              </div>

              <h3 className="mt-4 text-lg md:text-xl font-semibold text-slate-900">
                {b.title}
              </h3>

              <p className="mt-2 text-sm md:text-base text-slate-600 leading-relaxed">
                {b.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benifits;
